export default "<notifier-container></notifier-container>\n<router-outlet>\t</router-outlet>";